export default __webpack_public_path__ + "static/media/6.310e3ada.png";